import Link from "next/link";

const TermsConditionBtn = ({ checkedPolicy, isChecked }) => {
  return (
    <div className="flex items-center gap-1">
      <input
        type="checkbox"
        checked={isChecked}
        onChange={checkedPolicy}
        style={{ width: "1.3rem", height: "1rem" }}
      />
      <label htmlFor="terms" className=" sm:mt-0  md:mt-0">
        <span
          className=" text-[14px] xs:text-[16px] sm:text-[14px] md:text-[16px] lg:text-[16px] "
          style={{
            fontWeight: "300",
          }}
        >
          {/* I accept Elchemy’s */}
          <span>
            I agree with Elchemy’s
            <Link
              href={"/terms-and-conditions"}
              className="underline ml-1 font-medium"
              passHref={true}
            >
              terms and conditions
            </Link>
          </span>
        </span>
      </label>
    </div>
  );
};

export default TermsConditionBtn;
